'use strict';

var ConfigurationDiscontinuedRoutesDirective = function ConfigurationDiscontinuedRoutesDirective() {
  return {
    restrict: 'E',
    template: require('../templates/configuration-discontinued-routes.html'),
    controller: 'ConfigurationDiscontinuedRoutesController',
    link: function link() {}
  };
};
ConfigurationDiscontinuedRoutesDirective.$inject = [];
module.exports = ConfigurationDiscontinuedRoutesDirective;